import request from "@/utils/request";

const baseService = "autoapp-default-server-recovery";

export function login(data) {
  return request({
    url: "/autoapp-recovery-server-auth/api/recoveryManage/login",
    method: "post",
    data
  });
}

export function getInfo(token) {
  return request({
    url: "/autoapp-recovery-server-auth/api/recoveryManage/info",
    method: "get",
    params: { token }
  });
}

export function logout() {
  return request({
    url: "/vue-admin-template/user/logout",
    method: "post"
  });
}

export function getRouteAuthReq() {
  return request({
    url: "/autoapp-recovery-server-auth/api/tbl-sys-menu/getRouters",
    method: "get",
    params: {}
  });
}

export function downLoadCenter(data) {
  return request({
    url: `${baseService}/api/exportcenter/list`,
    method: "post",
    data
  });
}




// WEBPACK FOOTER //
// ./src/api/user.js